export default function Footer() {
  return (
    <footer id="footer" className="bg-secondary-900 text-secondary-300">
      <div className="max-w-6xl mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 mb-10">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <span className="w-9 h-9 flex items-center justify-center bg-primary-500 rounded-lg">
                <i className="ri-clapperboard-fill text-background-50 text-lg"></i>
              </span>
              <span className="text-lg font-heading font-bold text-background-50">番茄影视大全</span>
            </div>
            <p className="text-sm text-secondary-400 leading-relaxed">
              番茄影视大全致力于为广大追剧爱好者提供最新电视剧、电视剧全集更新免费在线观看服务。高清不缓冲，番茄追剧，最新剧集一网打尽。无需注册，即点即看。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">快速导航</h4>
            <nav className="flex flex-col gap-2">
              <a href="#hero" className="text-sm text-secondary-400 hover:text-background-50 transition-colors whitespace-nowrap cursor-pointer">首页</a>
              <a href="#index" className="text-sm text-secondary-400 hover:text-background-50 transition-colors whitespace-nowrap cursor-pointer">专题合集</a>
              <a href="#ranking" className="text-sm text-secondary-400 hover:text-background-50 transition-colors whitespace-nowrap cursor-pointer">热播排行榜</a>
              <a href="#cards" className="text-sm text-secondary-400 hover:text-background-50 transition-colors whitespace-nowrap cursor-pointer">精选推荐</a>
              <a href="#media" className="text-sm text-secondary-400 hover:text-background-50 transition-colors whitespace-nowrap cursor-pointer">精彩片花</a>
            </nav>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">热门分类</h4>
            <nav className="flex flex-col gap-2">
              <a href="#index" className="text-sm text-secondary-400 hover:text-background-50 transition-colors whitespace-nowrap cursor-pointer">最新电视剧</a>
              <a href="#index" className="text-sm text-secondary-400 hover:text-background-50 transition-colors whitespace-nowrap cursor-pointer">电视剧全集更新</a>
              <a href="#index" className="text-sm text-secondary-400 hover:text-background-50 transition-colors whitespace-nowrap cursor-pointer">热播剧集</a>
              <a href="#index" className="text-sm text-secondary-400 hover:text-background-50 transition-colors whitespace-nowrap cursor-pointer">电视剧在线看</a>
              <a href="#index" className="text-sm text-secondary-400 hover:text-background-50 transition-colors whitespace-nowrap cursor-pointer">韩剧美剧日剧</a>
            </nav>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">合作伙伴</h4>
            <p className="text-sm text-secondary-400 leading-relaxed">
              感谢所有合作伙伴的支持与信任，共同为追剧爱好者提供优质的内容与服务体验。
            </p>
          </div>
        </div>

        <div className="border-t border-secondary-800 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-secondary-500">
            &copy; 2026 番茄影视大全. 所有剧集版权归原权利人所有，本站仅提供在线观看索引服务。
          </p>
          <div className="flex items-center gap-4">
            <a href="#hero" className="text-xs text-secondary-500 hover:text-background-50 transition-colors whitespace-nowrap cursor-pointer">关于我们</a>
            <a href="#faq" className="text-xs text-secondary-500 hover:text-background-50 transition-colors whitespace-nowrap cursor-pointer">常见问题</a>
            <a href="#contact" className="text-xs text-secondary-500 hover:text-background-50 transition-colors whitespace-nowrap cursor-pointer">联系我们</a>
          </div>
        </div>
      </div>
    </footer>
  );
}